<template>
    <v-list-tile :key="character.name" avatar>
      <v-list-tile-avatar>
        <img :src="jobIcon">
      </v-list-tile-avatar>

      <v-text-field required
                    label="名前"
                    color="secondary"
                    height="25"
                    v-model="name"
                    class="mt-3"></v-text-field>

      <v-btn icon :disabled="isEdit" @click="updateName()">
        <v-icon color="success">edit</v-icon>
      </v-btn>
      <v-btn icon @click="deleteCharacter()">
        <v-icon color="error">delete</v-icon>
      </v-btn>
    </v-list-tile>
</template>

<script>
  export default {
    props: ['character', 'index', 'snackbar', 'deleteChar'],
    data: () => ({
      jobIcon: require('../assets/job/no.png'),
      name: '',
      isEdit: true,
    }),
    mounted: function () {
      this.jobIcon = require(`../assets/job/${this.character.job.value}.png`);
      this.name = this.character.name;
    },
    methods: {
      updateName: function () {
        const local = JSON.parse(localStorage.getItem('characters'));
        local[this.index].name = this.name;
        localStorage.setItem('characters', JSON.stringify(local));
        this.character.name = this.name;

        this.snackbar.text = 'キャラクター名を更新しました';
        this.snackbar.color = 'success';
        this.snackbar.isShow = true;
      },
      deleteCharacter: function () {
        this.deleteChar.name = this.character.name;
        this.deleteChar.index = this.index;
        this.deleteChar.isDialog = true;
      },
    },
    watch: {
      name: {
        handler: function () {
          this.isEdit = this.name !== this.character.name ? false : true;
        },
      },
    },
  }
</script>

<style>
.minusButton {
  color: #1E88E5
}
.plusButton {
  color: #D32F2F
}
</style>
